import React from "react";
import "./PaymentSuccessFailureModal.css";
import { Modal } from "react-bootstrap";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { PaymentSuccessIcon, PaymentFailureIcon } from "assets/SVGs/SVGs";

const PaymentSuccessFailureModal = ({
  show,
  type = "failure", // 'success' or 'failure'
  onClose,
  onViewReceipt,
  onPaymentFailure,
  transactionData = {},
}) => {
  const { amount = "", paymentMethod = "", date = "", transactionId = "" } = transactionData;

  const renderSuccessContent = () => (
    <>
      <div className="psfm_icon_container">
        <PaymentSuccessIcon className="psfm_icon_success" />
      </div>
      <p className="psfm_title">{titles?.payment_successful || "Payment Successful"}</p>
      {amount ? <p className="psfm_amount">{amount}</p> : null}
      <div className="psfm_separator" />
      <div className="psfm_txn_details">
        {paymentMethod ? <p className="psfm_text">{paymentMethod}</p> : null}
        {date ? <p className="psfm_text">{date}</p> : null}
        {transactionId ? <p className="psfm_text">{transactionId}</p> : null}
      </div>
      <div className="psfm_buttons">
        <CustomButton
          text={titles?.done || "Done"}
          className="psfm_primary_btn"
          width={"100%"}
          onClick={onClose}
        />
        <CustomButton
          text={titles?.view_receipt || "View Receipt"}
          className="psfm_secondary_btn"
          width={"100%"}
          onClick={onViewReceipt}
        />
      </div>
    </>
  );

  const renderFailureContent = () => (
    <>
      <div className="psfm_icon_container">
        <PaymentFailureIcon className="psfm_icon_failure" />
      </div>
      <p className="psfm_title">{titles?.payment_failed || "Payment Failed"}</p>
      <p className="psfm_text center">{titles?.payment_failed_message || "Something went wrong while processing your payment."}</p>
      <div className="psfm_buttons">
        <CustomButton
          text={titles?.ok || "OK"}
          className="psfm_primary_btn mt40"
          width={"100%"}
          onClick={onPaymentFailure || onClose}
        />
      </div>
    </>
  );

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      backdrop="true"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      className="psfm_container"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body className="psfm_body">
        <div className="psfm_content">
          {type === "success" ? renderSuccessContent() : renderFailureContent()}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentSuccessFailureModal;

